import React, { useEffect } from "react";
import { isMobile } from "react-device-detect";

const AllergyInfo = ({ onClickClose, contactMobileNumber }) => {
  let mobile;
  //eslint-disable-next-line
  if (__isBrowser__) {
    mobile = isMobile;
  }

  useEffect(() => {
    const popup = document.getElementById("popup-bg");

    if (popup) {
      popup.addEventListener("click", () => onClickClose(), false);
    }
  }, []);
  return (
    <div>
      <div className="modal-bg" id="popup-bg" />
      <div className="modal">
        {/* Header */}
        <div className="head-general with-back">
          <a href="javascript: void(0)" />
          <h4>Allergy And Dietary Requirements</h4>
          <a
            href="javascript: void(0)"
            onClick={onClickClose}
            className="close"
          >
            <icon className="icon icon-close" />
          </a>
        </div>
        {/* Header */}
        <div className="modal-body">
          <div className="row center-sm">
            <div className="col-sm-12">
              <div className="promo-error white-bg">
                <p>
                  Please contact the restaurant directly to check for allergen
                  and dietary information before placing an order.
                </p>
              </div>
              <div className="use-buttons">
                <button className="btn btn-blue" onClick={onClickClose}>
                  OK
                </button>
                {(mobile && (
                  <a
                    className="btn btn-gray"
                    href={`tel:${contactMobileNumber}`}
                  >
                    Call Restaurant
                  </a>
                )) || (
                  <button className="btn btn-gray" onClick={onClickClose}>
                    Call Restaurant: {contactMobileNumber}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllergyInfo;
